// src/LensFlare.jsx
import * as THREE from "three";
import { useLoader, useThree, useFrame } from "@react-three/fiber";
import { TextureLoader } from "three";
import { useState } from "react";

export default function LensFlare() {
  const { camera } = useThree();
  const flare1 = useLoader(TextureLoader, "/images/flare-1.jpg");
  const flare2 = useLoader(TextureLoader, "/images/flare-2.jpg");

  const targetPos = new THREE.Vector3(0, 0, 7.5);
  const [opacity, setOpacity] = useState(0);

  useFrame(() => {
    const distance = camera.position.distanceTo(targetPos);
    const x = camera.position.x;

    let targetOpacity = 0;

    // Only inside X range
    if (x > -5 && x < 5) {
      if (distance <= 5) {
        targetOpacity = 1;
      } else if (distance >= 10) {
        targetOpacity = 0;
      } else {
        // fade between 5 → 10
        targetOpacity = 1 - (distance - 5) / 5;
      }
    } else {
      targetOpacity = 0; // outside X range → invisible
    }

    // smooth fade
    setOpacity((prev) => THREE.MathUtils.lerp(prev, targetOpacity, 0.05));
  });

  return (
    <primitive object={camera}>
      {/* Center flare */}
      <mesh position={[0, 0.4, -10]}>
        <planeGeometry args={[2, 2]} />
        <meshBasicMaterial
          map={flare1}
          transparent
          opacity={opacity * 0.5}
          blending={THREE.AdditiveBlending}
          depthWrite={false}
        />
      </mesh>

      {/* Right-side flare */}
      <mesh position={[1.5, 0.8, -11]}>
        <planeGeometry args={[0.6, 0.6]} />
        <meshBasicMaterial
          map={flare2}
          transparent
          opacity={opacity * 0.5}
          blending={THREE.AdditiveBlending}
          depthWrite={false}
        />
      </mesh>
    </primitive>
  );
}
